export class MercadoriasModel {
  id: number;
  nome_padrao: string;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
  ncm: string;
  portaria: string;
  com_foto: boolean = false;
  portarias: any = [{ "portaria": null, "portaria_data": null }];
  instrucoes_normativas: any = [{ "instrucao": null, "data": null }];
  tempo_emitir_cert_mi: string;
  formula_odr: string = null;
  odr_inputs_config: any = [];
  duplicando: boolean = false;
  laudo_tec_exibir_peso_bruto: boolean = false;
  laudo_tec_exibir_peso_drenado: boolean = false;
  laudo_tec_exibir_peso_liquido: boolean = true;
  laudo_tec_calc_peso: string = 'peso_liquido';
  laudo_tec_exibir_temp_polpa: boolean = true;
  laudo_tec_exibir_brix: boolean = true;
  laudo_tec_exibir_pressao_polpa: boolean = true;
  laudo_tec_calibre_multiplo: boolean = false;
  laudo_tec_layout_calibre_com_valores: boolean = false;
  laudo_tec_id_unidade_medida: string = '239217541589259556';
}



// WEBPACK FOOTER //
// ./src/app/mercadorias/mercadorias.model.ts